import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import ImageCarousel from '../components/ImageCarousel';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import GuestReview from '../components/ReviewComponent';
import { Carousel } from 'react-responsive-carousel';
import Modal from '../components/Modal'; // Import the Modal component
import image1 from '../assets/image1.jpg'
import image2 from '../assets/image2.jpg'
import image3 from '../assets/image3.jpg'
import image4 from '../assets/image4.jpg'
import image5 from '../assets/image5.jpg'
import image6 from '../assets/image6.jpg'
import image7 from '../assets/image7.jpg'
import image8 from '../assets/image8.jpg'
import image9 from '../assets/image9.jpg'
import image10 from '../assets/image10.jpg'
import image11 from '../assets/image11.jpg'
import image12 from '../assets/image12.jpg'
import image13 from '../assets/image13.jpg'
import image14 from '../assets/image14.jpg'
import image15 from '../assets/image15.jpg'
import image16 from '../assets/image16.jpg'
import image17 from '../assets/image17.jpg'
import image18 from '../assets/image18.jpg'
import image19 from '../assets/image19.jpg'
import image20 from '../assets/image20.jpg'
import image21 from '../assets/image21.jpg'
import image22 from '../assets/image22.jpg'
import image23 from '../assets/image23.jpg'
import image24 from '../assets/image24.jpg'
import image25 from '../assets/image25.jpg'
import image26 from '../assets/image26.jpg'
import image27 from '../assets/image27.jpg'
import image28 from '../assets/image28.jpg'
import image29 from '../assets/image29.jpg'
import image30 from '../assets/image30.jpg'
import supabase from '../services/supabaseClient';
import image31 from '../assets/image31.jpg';
import image32 from '../assets/image32.jpg';
import image33 from '../assets/image33.jpg';
import image34 from '../assets/image34.jpg';
import { Carousel as MiniCarousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

// Styled-components for mini carousel in promo banner 2
const MiniPromoCarousel = styled.div`
    margin-top: 12px;
    width: 220px;
    max-width: 100%;
    & .carousel .slide {
        background: none !important;
    }
`;

const MiniPromoImg = styled.img`
    width: 100%;
    height: 120px;
    object-fit: cover;
    border-radius: 10px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.13);
`;

const HomePage: React.FC = () => {
    // Promo banner state, sessionStorage-persistent
    const [showPromo, setShowPromo] = useState(() => {
        return sessionStorage.getItem('promoDismissed') !== '1';
    });

    const handleClosePromo = () => {
        setShowPromo(false);
        sessionStorage.setItem('promoDismissed', '1');
    };
    const [showPromo2, setShowPromo2] = useState(() => {
        return sessionStorage.getItem('promo2Dismissed') !== '1';
    });
    const handleClosePromo2 = () => {
        setShowPromo2(false);
        sessionStorage.setItem('promo2Dismissed', '1');
    };
    const formatDate = (date: Date): string => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const [showBooking, setShowBooking] = useState(false);
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [name, setName] = useState<string>('');
    const [phone, setPhone] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [showModal, setShowModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState<string | null>('');
    const [availability, setAvailability] = useState<any>({});

    const insertBooking = async (homestay_id: string, start_date: string, end_date: string, uname: string, phone_number: string) => {
        try {
            const { data, error, status, statusText } = await supabase
                .from('booking_table')
                .insert([
                    {
                        homestay_id: homestay_id,
                        start_date: start_date,
                        end_date: end_date,
                        uname: uname,
                        phone_number: phone_number,
                        email: email || null,
                    },
                ]);

            if (error) {
                // Show full error object for debugging
                console.error('Supabase insert error:', error);
                alert(`Booking failed: ${error.message || 'unknown error'} (check console)`);
                return false;
            }

            console.log('Booking inserted:', data, { status, statusText });
            return true;
        } catch (err) {
            console.error('Unexpected error inserting booking:', err);
            alert('Booking failed: unexpected error (check console)');
            return false;
        }
    };

    const datePickerRef = useRef<HTMLDivElement | null>(null);

    const generateHouseCaptions = (start: number, end: number, caption: string) => {
        const captions = [];
        for (let i = start; i <= end; i++) {
            captions.push(`${caption}`);
        }
        return captions;
    };

    const homestay1To4Captions = generateHouseCaptions(1, 13, "Kampung Stay 1-4");
    const homestayTabanakCaptions = generateHouseCaptions(14, 25, "Sri Payung Homestay");
    const homestay2Captions = generateHouseCaptions(26, 30, "Sri Payung Homestay 2");

    const houseCaptions = [...homestay1To4Captions, ...homestayTabanakCaptions, ...homestay2Captions];

    const images = [
        image1, image2, image3, image4, image5, image6, image7, image8,
        image9, image10, image11, image12, image13, image14, image15,
        image16, image17, image18, image19, image20, image21, image22,
        image23, image24, image25, image26, image27, image28, image29, image30
    ];

    const handleBooking = async () => {
        if (startDate && endDate && name && phone && selectedImage) {
            const start_iso = formatDate(startDate);
            const end_iso = formatDate(endDate);
            const ok = await insertBooking(selectedImage, start_iso, end_iso, name, phone);
            const bookingDetails = `Booking from ${start_iso} to ${end_iso}`;
            if (!ok) return; // abort if insert failed
            const encodedMessage = encodeURIComponent(`${bookingDetails}\n\nName: ${name}\n\nPhone Number: ${phone}\n\nEmail: ${email || '-'} \n\nHomestay: ${selectedImage} `);
            const whatsappURL = `https://api.whatsapp.com/send?phone=60195881945&text=${encodedMessage}`;

            window.open(whatsappURL, '_blank');
        } else {
            if (startDate === null || endDate === null) {
                alert('Please select both start and end dates.');
            } else if (phone === '') {
                alert('Please input your phone number');
            } else if (selectedImage === '') {
                setShowModal(true)
                alert('Please select which homestay you want to stay');
            } else {
                alert('Please input your name');
            }
        }
    };

    const fetchData = async () => {
        try {
            const { data: bookingData, error: bookingError } = await supabase
                .from('booking_table')
                .select('*');

            console.debug('fetchData result', { bookingData, bookingError });

            if (bookingError) {
                throw bookingError;
            }

            const availabilityMap: { [date: string]: string[] } = {};

            bookingData.forEach((item: any) => {
                // Parse dates as UTC to avoid local timezone shifts when converting to ISO date strings
                const start = new Date(String(item.start_date) + 'T00:00:00Z');
                const end = new Date(String(item.end_date) + 'T00:00:00Z');
                // normalize homestay id to string so comparisons are consistent
                const hid = String(item.homestay_id).trim();

                for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
                    const dateString = d.toISOString().split('T')[0];
                    if (!availabilityMap[dateString]) {
                        availabilityMap[dateString] = [];
                    }
                    if (!availabilityMap[dateString].includes(hid)) {
                        availabilityMap[dateString].push(hid);
                    }
                }
            });

            setAvailability(availabilityMap); // ✅ KEEP ONLY THIS
            console.debug('Fetched availability map:', availabilityMap);
        } catch (err) {
            console.error(err); // ✅ no setError
        }
    };

    // Debug when selectedImage changes to ensure it matches availability items
    useEffect(() => {
        if (selectedImage) {
            console.debug('Selected homestay:', selectedImage);
        }
    }, [selectedImage]);

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (showBooking && datePickerRef.current) {
            datePickerRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [showBooking]);

    const handleModalClose = (house: any) => {
        setShowModal(false);
        setShowBooking(true);
        setSelectedImage(house)
    };

    return (
        <>
            {showPromo && (
                <PromoBanner>
                    <PromoIcon>🔥</PromoIcon>
                    <PromoContent>
                        <PromoTitle>30% OFF Long Stay!</PromoTitle>
                        <PromoText>
                            Book for <b>14 days or more</b> and enjoy a <b>30% discount</b> on your total stay.<br />
                        </PromoText>
                    </PromoContent>
                    <ClosePromoButton onClick={handleClosePromo} aria-label="Close promotion">×</ClosePromoButton>
                </PromoBanner>

            )}
            {showPromo2 && (
                <PromoBanner style={{ top: showPromo ? 200 : 24 }}>
                    <PromoIcon>🌅</PromoIcon>
                    <PromoContent>
                        <PromoTitle>Your perfect vacation with outdoor activities</PromoTitle>
                        <PromoText>
                            <b>Scuba, snorkeling & island hopping</b> around clear water <b>Darvel Bay</b>
                        </PromoText>
                        <PromoText>
                            Thrilling outdoor adventures await with <b>ATV</b> rides through scenic trails!
                        </PromoText>
                        <MiniPromoCarousel>
                            <MiniCarousel
                                showThumbs={false}
                                showStatus={false}
                                showIndicators={false}
                                infiniteLoop
                                autoPlay
                                interval={2500}
                                stopOnHover={false}
                                swipeable
                                emulateTouch
                                dynamicHeight={false}
                            >
                                <div>
                                    <MiniPromoImg src={image31} alt="Scuba adventure" />
                                </div>
                                <div>
                                    <MiniPromoImg src={image32} alt="Snorkeling fun" />
                                </div>
                                <div>
                                    <MiniPromoImg src={image33} alt="Island hopping" />
                                </div>
                                <div>
                                    <MiniPromoImg src={image34} alt="ATV" />
                                </div>
                            </MiniCarousel>
                        </MiniPromoCarousel>
                    </PromoContent>
                    <ClosePromoButton onClick={handleClosePromo2} aria-label="Close early bird promo">×</ClosePromoButton>
                </PromoBanner>
            )}

            <HomePageWrapper>
                <Title>Home2stay Inap Sri Payung</Title>
                <ImageCarousel onBookNowClick={() => setShowModal(true)} />
                {showModal && (
                    <Modal onClose={() => {
                        setShowModal(false);
                        setShowBooking(true);
                    }}>
                        <CarouselWrapper>
                            <Carousel autoPlay infiniteLoop showThumbs={false}>
                                {images.map((img, index) => (
                                    <div key={index}>
                                        <ImageWrapper>
                                            <img src={img} alt={houseCaptions[index]} />
                                        </ImageWrapper>
                                        <p className="legend">{houseCaptions[index]}</p> {/* Add Caption */}
                                    </div>
                                ))}
                            </Carousel>
                        </CarouselWrapper>
                        <ButtonGroup>
                            <HouseButton onClick={() => handleModalClose('Kampung Stay 1')}>Kampung Stay 1</HouseButton>
                            <HouseButton onClick={() => handleModalClose('Kampung Stay 2')}>Kampung Stay 2</HouseButton>
                            <HouseButton onClick={() => handleModalClose('Kampung Stay 3')}>Kampung Stay 3</HouseButton>
                            <HouseButton onClick={() => handleModalClose('Kampung Stay 4')}>Kampung Stay 4</HouseButton>
                            <HouseButton onClick={() => handleModalClose('Sri Payung Homestay')}>Sri Payung Homestay</HouseButton>
                            <HouseButton onClick={() => handleModalClose('Sri Payung Homestay 2')}>Sri Payung Homestay 2</HouseButton>
                        </ButtonGroup>
                    </Modal>
                )}
                {showBooking && (
                    <BookingWrapper ref={datePickerRef}>
                        <BookingTitle>Select Your Dates</BookingTitle>
                        <BookingSubTitle>Inform our host on your chosen date</BookingSubTitle>
                        <DatePickerWrapper>
                            <DatePicker
                                selected={startDate || undefined}
                                onChange={(date: Date | null) => setStartDate(date)}
                                startDate={startDate || undefined}
                                endDate={endDate || undefined}
                                selectsStart
                                dateFormat="yyyy/MM/dd"
                                placeholderText="Start Date"
                                filterDate={(date) => {
                                    const formattedDate = formatDate(date);
                                    const today = new Date();
                                    const yesterday = new Date(today);
                                    yesterday.setDate(today.getDate() - 1);

                                    const formattedYesterday = formatDate(yesterday);
                                    const hid = selectedImage ? String(selectedImage).trim() : null;
                                    const blocked = hid && availability[formattedDate] && availability[formattedDate].includes(hid);
                                    if (hid) console.debug(`filterDate check ${formattedDate} hid=${hid} blocked=${!!blocked}`);
                                    return formattedDate > formattedYesterday && !blocked;
                                }}
                            />
                            <DatePicker
                                selected={endDate || undefined}
                                onChange={(date: Date | null) => setEndDate(date)}
                                startDate={startDate || undefined}
                                endDate={endDate || undefined}
                                selectsEnd
                                minDate={startDate ? new Date(startDate) : undefined}
                                dateFormat="yyyy/MM/dd"
                                placeholderText="End Date"
                                filterDate={(date) => {
                                    const formattedDate = formatDate(date);
                                    const today = new Date();
                                    const yesterday = new Date(today);
                                    yesterday.setDate(today.getDate() - 1);

                                    const formattedYesterday = formatDate(yesterday);
                                    const hid = selectedImage ? String(selectedImage).trim() : null;
                                    const blocked = hid && availability[formattedDate] && availability[formattedDate].includes(hid);
                                    if (hid) console.debug(`filterDate (end) check ${formattedDate} hid=${hid} blocked=${!!blocked}`);
                                    return formattedDate > formattedYesterday && !blocked;
                                }}
                            />
                        </DatePickerWrapper>
                        <InputWrapper>
                            <InputField
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Enter your name"
                            />
                            <InputField
                                type="text"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                placeholder="Enter your phone number"
                            />
                            <InputField
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email"
                            />
                        </InputWrapper>
                        <h5>Selected Homestay: {selectedImage}</h5>
                        {selectedImage === 'Sri Payung Homestay' && (
                            <HomestayInfo>
                                <ul>
                                    <li>👉 RM420 / night</li>
                                    <li>👉 RM450 / weekend</li>
                                    <li>👉 50% off monthly</li>
                                    <li>👉 4 bilik</li>
                                    <li>👉 3 tandas (2 tandas ada water heater)</li>
                                    <li>👉 Ada Coway, ada oven Panasonic</li>
                                </ul>
                            </HomestayInfo>
                        )}
                        {(selectedImage === 'Kampung Stay 1' || selectedImage === 'Kampung Stay 2') && (
                            <HomestayInfo>
                                <ul>
                                    <li>👉 RM120 / mlm</li>
                                    <li>👉 2 bilik</li>
                                    <li>👉 1 aircond</li>
                                    <li>👉 Ruang dapur</li>
                                    <li>👉 Peralatan memasak</li>
                                    <li>👉 1 tandas dgn water heater</li>
                                    <li>👉 TV, meja makan & sofa</li>
                                </ul>
                            </HomestayInfo>
                        )}
                        {(selectedImage === 'Kampung Stay 3' || selectedImage === 'Kampung Stay 4') && (
                            <HomestayInfo>
                                <ul>
                                    <li>👉 RM150 / mlm</li>
                                    <li>👉 2 bilik</li>
                                    <li>👉 2 aircond</li>
                                    <li>👉 TV Android</li>
                                    <li>👉 Peti sejuk</li>
                                    <li>👉 1 sofa / bed</li>
                                    <li>👉 Peralatan memasak</li>
                                    <li>👉 1 tandas dgn water heater</li>
                                </ul>
                            </HomestayInfo>
                        )}
                        {selectedImage === 'Sri Payung Homestay 2' && (
                            <HomestayInfo>
                                <ul>
                                    <li>👉 RM180 / mlm</li>
                                    <li>👉 4 bilik</li>
                                    <li>👉 TV dgn siaran NJOI</li>
                                    <li>👉 Peti sejuk</li>
                                    <li>👉 Coway</li>
                                    <li>👉 Peralatan memasak</li>
                                    <li>👉 1 tandas & 2 kamar mandi</li>
                                </ul>
                            </HomestayInfo>
                        )}
                        <ButtonWrapper>
                            <CloseButton onClick={() => setShowBooking(false)}>Close</CloseButton>
                            <BookingButton onClick={handleBooking}>Confirm</BookingButton>
                        </ButtonWrapper>
                        {selectedImage === 'Kampung Stay 1' ||
                            selectedImage === 'Kampung Stay 2' ||
                            selectedImage === 'Kampung Stay 3' ||
                            selectedImage === 'Kampung Stay 4' || selectedImage === 'Sri Payung Homestay 2' ? <MapWrapper>
                            <iframe
                                title="Kampung Stay & Sri Payung Homestay 2 Map"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d993.5641770533502!2d118.28454839999998!3d5.0620872!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x323f0b0edb05ddab%3A0xe614614ef1534af1!2sDarvel%20Bay%20Homestay!5e0!3m2!1sen!2smy!4v1721892187050!5m2!1sen!2smy"
                                width="600"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </MapWrapper> : <MapWrapper>
                            <iframe
                                title="Sri Payung Homestay Map"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d993.6088883685034!2d118.3118181695802!3d5.032895735618385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x323f9fed96705f03%3A0xe494096278b3979b!2s4078%2C%20Jalan%20Tabanak%203%2C%2091100%20Lahad%20Datu%2C%20Sabah!5e0!3m2!1sen!2smy!4v1723639127864!5m2!1sen!2smy"
                                width="600"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade">
                            </iframe>
                        </MapWrapper>}
                    </BookingWrapper>
                )}
            </HomePageWrapper>
            <ReviewsSection>
                {reviewsData.map((review, index) => (
                    <GuestReview key={index} author={review.author} text={review.text} />
                ))}
            </ReviewsSection>
        </>
    );
};

const Title = styled.h1`
    font-size: 2.5em;
    margin-bottom: 20px;
    color: white;
    border: 3px solid white;
    border-radius: 15px;
    padding: 10px 20px;
    display: inline-block;
    background-color: rgba(0, 0, 0, 0.3);
    opacity: 0;
    animation: fadeInSlideIn 2s forwards;

    @keyframes fadeInSlideIn {
        0% {
            opacity: 0;
            transform: translateX(-20px);
        }
        100% {
            opacity: 1;
            transform: translateX(0);
        }
    }
`;

const HomePageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 20px;
`;

const BookingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background-color: #f8f9fa; /* Optional: background color */
    border-radius: 10px;
    margin-top: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const BookingTitle = styled.h2`
    font-size: 2em;
    margin-bottom: 2px;
`;

const BookingSubTitle = styled.h2`
    font-size: 1em;
    margin-bottom: 20px;
`;

const DatePickerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
`;

const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    padding-top: 15px
`;

const BookingButton = styled.button`
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;

    &:hover {
        background-color: #0056b3;
    }
`;

const CloseButton = styled.button`
    padding: 10px 28px;
    background-color: #ccc;
    color: black;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;

    &:hover {
        background-color: #bbb;
    }
`;

const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;
`;

const InputField = styled.input`
    padding: 2px;
    border: 1px solid #000000;
    border-radius: 2px;
    width: 100%;
    box-sizing: border-box;
`;

const MapWrapper = styled.div`
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    height: 450px; /* Fixed height for the map */
`;

const ReviewsSection = styled.div`
    width: 85%;
    margin: 0 auto;
    padding: 20px;
    background-color: transparent;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: center;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 10px;
    }
`;

const ButtonGroup = styled.div`
    display: flex;
    justify-content: space-around;
    width: 100%;
    margin-top: 20px;
    flex-wrap: wrap; /* Allow the buttons to wrap onto a new line */

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
    }
`;


const HouseButton = styled.button`
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    margin-bottom: 10px; /* Add space between buttons in column mode */

    &:hover {
        background-color: #0056b3;
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.5);
    }

    &:disabled {
        background-color: grey;
        cursor: not-allowed; /* Change cursor to indicate the button is not clickable */
    }

    @media (max-width: 768px) {
        width: 80%; /* Take up most of the width in smaller devices */
    }
`;

const HomestayInfo = styled.div`
    margin-top: 12px;
    padding: 14px;
    background-color: #e9f5ff;
    border-radius: 8px;
    text-align: left;
    width: 100%;
    max-width: 420px;

    ul {
        margin: 0;
        padding-left: 18px;
    }

    li {
        margin-bottom: 6px;
        font-size: 14px;
    }
`;

const ImageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    height: 400px;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: contain; /* Ensure the image covers the container */
    }
`;

const CarouselWrapper = styled.div`
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
    flex-wrap: wrap
    width: 400px;
    margin: 0 auto;
    animation: fadeInSlideIn 2s forwards;
    text-align: center;

        @keyframes fadeInSlideIn {
        0% {
            opacity: 0;
            transform: translateX(-20px);
        }
        100% {
            opacity: 1;
            transform: translateX(0);
        }
    }
`;

const reviewsData = [
    { author: 'Arif', text: 'Amazing stay! Highly recommend.' },
    { author: 'Muhd Nuaim', text: 'Loved the environment, cold taking places when at dawn, even when the aircond is off' },
    { author: 'Aqilah', text: 'I like the environment and the host`s food, I really love the Nasi Kuning' },
    // Add more reviews as needed
];

export default HomePage;

const PromoBanner = styled.div`
    position: fixed;
    top: 24px;
    right: 32px;
    background: linear-gradient(90deg, #ff9800 0%, #ff5722 100%);
    color: #fff;
    padding: 18px 24px 18px 18px;
    border-radius: 12px;
    box-shadow: 0 4px 18px rgba(0,0,0,0.13);
    z-index: 9999;
    font-size: 1.08em;
    display: flex;
    align-items: center;
    gap: 18px;
    min-width: 220px;
    max-width: 400px;
    width: auto;
    animation: fadeIn 0.5s;
    border: 2px solid #fff3e0;
    @keyframes fadeIn {
        from { opacity: 0; transform: translateY(-20px) translateX(40px);}
        to { opacity: 1; transform: translateY(0) translateX(0);}
    }

    @media (max-width: 600px) {
        left: 50%;
        right: auto;
        top: 16px;
        transform: translateX(-50%);
        min-width: 0;
        max-width: 95vw;
        width: 95vw;
        padding: 14px 8px 14px 12px;
        font-size: 0.98em;
    }
`;

const PromoIcon = styled.span`
    font-size: 2.1em;
    margin-right: 6px;
    filter: drop-shadow(0 1px 2px #ffb300);
`;

const PromoContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
`;

const PromoTitle = styled.div`
    font-weight: bold;
    font-size: 1.13em;
    margin-bottom: 2px;
    letter-spacing: 0.5px;
`;

const PromoText = styled.div`
    font-size: 0.98em;
    line-height: 1.4;
`;

const ClosePromoButton = styled.button`
    background: transparent;
    border: none;
    color: #333;
    font-size: 1.5em;
    margin-left: 12px;
    cursor: pointer;
    line-height: 1;
    &:hover {
        color: #e57373;
    }
`;
